'use client'
import React, { useEffect } from 'react'
import { SnackbarProvider } from 'notistack'
import { ApolloProvider } from '@apollo/client/react'
import { useAtom } from 'jotai'

import { useRouter } from 'next/navigation'

import { AdminLayout } from '@docpace/admin-react-components/AdminLayout'
import { apolloClient, serverHostname } from '@docpace/apps/admin-app/client'
import { ctxPracticeIdAtom } from '@docpace/shared-react-atoms'
import adminRoutes from '@docpace/shared-react-routes/adminRoutes'

import { useIsChangingRoute } from '@docpace/shared-react-hooks/useIsChangingRoute'
import { useNextQueryParam } from '@docpace/shared-react-hooks/useNextQueryParam'
import { useSessionSharing } from '@docpace/shared-react-hooks/useSessionSharing'

export default function AdminLayoutClientComponent({
  // Layouts must accept a children prop.
  // This will be populated with nested layouts or pages
  children,
}: {
  children: React.ReactNode
}) {
  useIsChangingRoute()
  const router = useRouter()
  const { isInitialized } = useSessionSharing({
    // another tab signed out — drop cached data and leave authed pages
    onSessionCleared: async () => {
      try {
        await apolloClient.clearStore()
      } catch (e) {}
      router.replace(adminRoutes.Signin.hrefNext())
    },
  })
  const practiceId = useNextQueryParam('practiceId')
  const [, setContextPracticeId] = useAtom(ctxPracticeIdAtom)
  useEffect(() => {
    setContextPracticeId(practiceId)
  }, [practiceId])

  return (
    <ApolloProvider client={apolloClient}>
      <SnackbarProvider
        maxSnack={8}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >

        {isInitialized && <AdminLayout>
          {children}
        </AdminLayout>}
      </SnackbarProvider>
    </ApolloProvider>
  )
}